angular.module('wbFilters').filter('parseAddress', () => (address) => {
  if (!address) { return; }

  return [
    address.street,
    address.city,
    address.province,
    address.country,
    address.postalCode
  ].filter(e => e).join(', ');
});
